import { get } from 'lodash';

// TODO: add jsdoc
// TODO: move all language logic from stores and actions in here
export class LanguageService {
  
  static languageStorageKey = 'lang';
  
  setLanguageToSessionStorage(lang, account) {
    const existingLanguageData = this._getLanguageDataFromSessionStorage();
    const newLanguageData = this._formLanguageDataForSessionStorage(lang, account);
    window.sessionStorage.setItem(
      LanguageService.languageStorageKey, JSON.stringify({ ...existingLanguageData, ...newLanguageData })
    );
  }
  
  getCurrentLanguageFromSessionStorage(account) {
    const userId = account.id;
    return get(this._getLanguageDataFromSessionStorage(), String(userId), null);
  }
  
  removeCurrentLanguageFromSessionStorage(account) {
    const storageLangData = this._getLanguageDataFromSessionStorage();
    const userId = account.id;
    delete storageLangData[userId];
    window.sessionStorage.setItem(
      LanguageService.languageStorageKey, JSON.stringify(storageLangData)
    );
  }
  
  _getLanguageDataFromSessionStorage() {
    return JSON.parse(window.sessionStorage.getItem(LanguageService.languageStorageKey) || null) || {};
  }
  
  _formLanguageDataForSessionStorage(lang, account) {
    const userId = account.id;
    return { [userId]: lang };
  }
  
}

export const languageService = new LanguageService();


